import React from 'react';
import { Route } from 'react-router';
import { URL } from '../../constant';
import { PwInquiry, PwInquirySuccess } from '../account/GM';
import { Login, MyPageV2, Agreed, JoinSuccess, Leave, JoinV2 } from './account';
import LeaveSuccess from './account/LeaveSuccess';

function AccountGB() {
  return (
    <React.Fragment>
      <Route path={URL.ACCOUNT.MY_PAGE} component={MyPageV2} />
      {/* <Route path={URL.ACCOUNT.MY_PAGE} component={MyPage} /> */}
      <Route path={URL.ACCOUNT.LOGIN} component={Login} />
      <Route path={URL.ACCOUNT.LEAVE} component={Leave} />
      <Route path={URL.ACCOUNT.LEAVE_SUCCESS} component={LeaveSuccess} />
      <Route path={URL.ACCOUNT.PW_INQUIRY} component={PwInquiry} />
      <Route path={URL.ACCOUNT.PW_INQUIRY_SUCCESS} component={PwInquirySuccess} />
      <Route path={URL.ACCOUNT.JOIN.I} exact component={JoinV2} />
      <Route path={URL.ACCOUNT.JOIN.SUCCESS} exact component={JoinSuccess} />
      <Route path={URL.ACCOUNT.POLICY.I} component={Agreed} />
    </React.Fragment>
  );
}

export default AccountGB;